var map = {
	"./brands/brands.module": [
		"./src/app/brands/brands.module.ts",
		"common",
		"brands.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"products.module",
		"common"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports.module",
		"common"
	],
	"./staff/staff.module": [
		"./src/app/staff/staff.module.ts",
		"common",
		"staff.module"
	],
	"./stores/stores.module": [
		"./src/app/stores/stores.module.ts",
		"common",
		"stores.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main